import React from 'react';

function HomeBlurb() {
    return ( 
        <p className="homeblurb">I’m a junior at Harvard who is passionate about CS, 
            Philosophy, and lifting weights. I love thinking about 
            challenging technical problems and working with creative 
            individuals to solve them.</p>
    );
}

export default HomeBlurb;